import { render, staticRenderFns } from "./CascadeSelectorAssetAssign.vue?vue&type=template&id=04a1e1f6&"
import script from "./CascadeSelectorAssetAssign.vue?vue&type=script&lang=js&"
export * from "./CascadeSelectorAssetAssign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports